import { render, staticRenderFns } from "./LandingPageFooter.vue?vue&type=template&id=eae6e2c6&scoped=true"
import script from "./LandingPageFooter.vue?vue&type=script&lang=ts"
export * from "./LandingPageFooter.vue?vue&type=script&lang=ts"
import style0 from "./LandingPageFooter.vue?vue&type=style&index=0&id=eae6e2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae6e2c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VDivider})
